import React from 'react';
import { isEmpty, map, times, get, find, isEqual, size, head, castArray, isNil } from 'lodash';

// local Dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { ADMINISTRATION_STATUS } from 'constants/common';
import { button as Button } from 'modules/button';
import { SingleSelectAndSearch } from 'modules/singleSelectAndSearch';
import { fileField as FileField } from 'ui/views/generic/fileField';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { wellViewAdministration as WellViewAdministration } from 'ui/views/widgets/wellViewAdministration';
 *
 * // render
 * <WellViewAdministration propName='propValue'/>
 */

//  contact info view
const ContactInfo = ( props ) => {
	return (
		<div className='ui-well-view-administration__settings__panel__contact-body'>
			{ map( props.contacts, ( option ) => {
				const actionsVisibility = option.actionsVisibility;
				return (
					<div
						key={ option.id }
						className='ui-well-view-administration__settings__panel__contact-body__contact'
					>
						{ /* header */ }
						<div className='ui-well-view-administration__settings__panel__contact-body__contact__type-detail'>
							<div className='ui-well-view-administration__settings__panel__contact-body__contact__type-detail__type'>
								{ option.type }
							</div>
						</div>

						{ /* contact number */ }
						<div className='ui-well-view-administration__settings__panel__contact-body__contact__contact-number'>
							{ option.contact }
						</div>

						{ /* the partition */ }
						<div className='ui-well-view-administration__settings__panel__contact-body__contact__partition' />

						{ /* footer Actions */ }
						<div className='ui-well-view-administration__settings__panel__contact-body__contact__actions'>
							{ actionsVisibility.edit ? (
								<div
									className='ui-well-view-administration__settings__panel__contact-body__contact__actions__action'
									onClick={ () =>
										props.onEditClick( {
											id: option.id,
											title: option.type,
											contact: option.contact,
											type: 'contact',
										} )
									}
								>
									<div className='ui-well-view-administration__settings__panel__contact-body__contact__actions__action__icon'>
										<Icon
											name='edit'
											fill={
												actionsVisibility.edit
													? THEME.themeColorPrimary2
													: '#7a7a7a'
											}
										/>
									</div>
									<div className='ui-well-view-administration__settings__panel__contact-body__contact__actions__action__name'>
										{ getLabel( get( props.editAction, 'title', {} ) ) }
									</div>
								</div>
							) : null }
						</div>
					</div>
				);
			} ) }
		</div>
	);
 };

/* -------------------------------------------- */

const SplashPageContentInfo = ( props ) => {
	const { fieldsAndTitles } = props;

	// extract field Titles
	const contentField = find( fieldsAndTitles, { name: 'splashPageContent' } );
	const endDateField = find( fieldsAndTitles, { name: 'endDate' } );

	return (

        ( props.showContentDiv  ? (
            <div className='ui-well-view-administration__settings__panel__content-body'>
               
                <div className='ui-well-view-administration__settings__panel__content-body__info'>
					{ endDateField ? (
						<div className='ui-well-view-administration__settings__panel__content-body__info__detail'>
							<div className='ui-well-view-administration__settings__panel__content-body__info__detail__title'>
								{ getLabel( endDateField.title ) }
							</div>
							<div className='ui-well-view-administration__settings__panel__content-body__info__detail__value'>
								{ props.content.endDate }
							</div>
						</div>
						) : null }
                </div>
				{ contentField ? (
					<div className='ui-well-view-administration__settings__panel__content-body__info'>
						<div className='ui-well-view-administration__settings__panel__content-body__info__detail__title'>
							{ getLabel( contentField.title ) }
						</div>
						<div className='ui-well-view-administration__settings__panel__content-body__info__detail__value'>
							{ props.content.splashPageContent }
						</div>
					</div>
				) : null }
                
                { props.actionsVisibility.edit ? (
                    <div
                        className='ui-well-view-administration__settings__panel__content-body__action'
                        onClick={ () => props.onEditClick( { type: 'content' } ) }
                    >
                        <div className='ui-well-view-administration__settings__panel__content-body__action__icon'>
                            <Icon name='edit' fill={ THEME.themeColorPrimary2 } />
                        </div>
                        <div className='ui-well-view-administration__settings__panel__content-body__action__name'>
                            { getLabel( get( props.editAction, 'title', {} ) ) }
                        </div>
                    </div>
                ) : null }
            </div>
        ) : null )
	);
 };

/* -------------------------------------------- */

const WhiteLabelInfo = ( props ) => {
	const fileField = head( props.fieldsAndTitles );

	const description = (
		<>
			<div>{ `${ getLabel( fileField.descriptionTitleForDimensions ) }: ${ get( fileField, 'config.resolution.maxWidth', {} ) } * ${ get( fileField, 'config.resolution.maxHeight', {} ) } ` }</div>
			<div>{ `${ getLabel( fileField.descriptionTitleForMaxSize ) }` }</div>
		</>
	);
	
	return (
		<div className='ui-well-view-administration__settings__panel__logo-body'>
			<div className='ui-well-view-administration__settings__panel__logo-body__title'>
				{ getLabel( fileField.title ) }
			</div>
			<div className='ui-well-view-administration__settings__panel__logo-body__information'>
				<FileField
					onChange= { ( { fileName } ) => props.onActionClick( {
						type: 'whiteLabel',
						data: { action: 'upload', fileName: fileName }
					} ) }
					constraints={ {
						allowedMultipleFiles: false,
						...get( fileField, 'config', {} ),
						errorMessage: get( fileField, 'errorMessage' )
					} }
					className='ui-well-view-administration__settings__panel__logo-body__information__uploader'
					disabled={ false }
					readOnly={ false }
					required={ false }
					selectedFile={ isNil( get( props, 'file', null ) ) ? null : castArray( get( props, 'file', null ) ) }
					onFileRemove={ () => props.onActionClick( {
						type: 'whiteLabel',
						data: { action: 'delete' }
					} ) }
					canDelete={ get( props, 'actionsVisibility.delete' ) }
					description= { description }
					uploadUrl={ fileField.url }
				/>
			</div>
		</div>
	);
 };

/* -------------------------------------------- */

export const wellViewAdministrationSuccess = ( props ) => {
	const { settingInformation, subWidgets } = props;

	const actions = get( subWidgets, 'actionsConfig', [] );
	const enableAction = find( actions, { name: ADMINISTRATION_STATUS.ENABLED } );
	const disableAction = find( actions, { name: ADMINISTRATION_STATUS.DISABLED } );
	const editAction = find( actions, { name: 'edit' } );

	return (
		<div className='ui-well-view-administration'>
			{ /* Cag filter section : 1 */ }
			<div className='ui-well-view-administration__cag-filter'>
				<div className='ui-well-view-administration__cag-filter__title'>
					{ getLabel( props.title ) }
				</div>
				{ map( props.fields, ( field ) => {
					return (
						<div
							className='ui-well-view-administration__cag-filter__filter'
							key={ field.name }
						>
							<div className='ui-well-view-administration__cag-filter__filter__title'>
								{ getLabel( field.title ) }
							</div>

							<SingleSelectAndSearch
								{ ...field }
								removeSelectedOptionOnClear={ false }
								className={
									'ui-well-view-administration__cag-filter__filter__dropdown'
								}
								classForBottomTitle={
									'ui-well-view-administration__cag-filter__filter__dropdown__select-text'
								}
								classForBottomValue={ 'ui-well-view-administration__cag-filter__filter__dropdown__selected-text' }
								value={ get( props, 'cagSelected' ) }
								isLabelVisible={ false }
								showDefaultLabelSelect={ true }
								requestParams={ field.pagination }
								disablePagination={ false }
								onChange={ ( { options, value } ) => {
									if ( 0 === size( options ) ) {
										props.onClickCancel();
									} else {
										props.onCagSelect( {
											value: value,
											url: field.onSelectUrl,
										} );
									}
								} }
							/>
						</div>
					);
				} ) }
			</div>

			{ /* Settings Info Section */ }
			<div className='ui-well-view-administration__settings'>
				{ map( props.collapsedSettings, ( setting ) => {
					return (
						<div
							key={ setting.name }
							className='ui-well-view-administration__settings__panel'
						>
							<div className='ui-well-view-administration__settings__panel__header'>
								{ /* Showing title and icon */ }
								<Icon name={ setting.name } width={ 16 } height={ 16 } />
								<div className='ui-well-view-administration__settings__panel__header__title'>
									{ getLabel( setting.title ) }
								</div>

								{ /* If setting info is available then show the status along with the title */ }
								{ !isEmpty( settingInformation ) &&
								setting.config.hasModuleStatus ? (
									<div className='ui-well-view-administration__settings__panel__header__information'>
										<div className='ui-well-view-administration__settings__panel__header__information__subtitle'>{ `(${
											ADMINISTRATION_STATUS.ENABLED ===
											settingInformation[ setting.name ].status
												? getLabel( subWidgets[ setting.name ].enabledStatusTitle )
												: getLabel( subWidgets[ setting.name ].disabledStatusTitle )
										})` }</div>
										<div className='ui-well-view-administration__settings__panel__header__information__action'>
											{ ADMINISTRATION_STATUS.DISABLED ===
											settingInformation[ setting.name ].status ? (
												<Button
													type='button'
													size='small'
													label={ enableAction.title }
													outline={ true }
													onClick={ () =>
														props.onActionClick( {
															type: setting.name,
															data: { status: ADMINISTRATION_STATUS.ENABLED },
														} )
													}
												/>
											) : (
												<Button
													type='button'
													size='small'
													label={ disableAction.title }
													outline={ false }
													onClick={ () =>
														props.onActionClick( {
															type: setting.name,
															data: { status: ADMINISTRATION_STATUS.DISABLED },
														} )
													}
												/>
											) }
										</div>
									</div>
								) : null }
							</div>

							{ /* contact Settings Info */ }
							{ !isEmpty( settingInformation ) &&
							'contactInformation' === setting.name ? (
								<ContactInfo
									contacts={ settingInformation[ setting.name ].items }
									enableAction={ enableAction }
									disableAction={ disableAction }
									editAction={ editAction }
									onActionClick={ props.onActionClick }
									onEditClick={ props.onEditClick }
								/>
							) : null }

							{ /* contact Settings Info */ }
							{ !isEmpty( settingInformation ) &&
							'splashPageContent' === setting.name ? (
								<SplashPageContentInfo
									content={ settingInformation[ setting.name ].items }
									actionsVisibility={ settingInformation[ setting.name ].actionsVisibility }
									editAction={ editAction }
									onEditClick={ props.onEditClick }
									showContentDiv={ props.showContentDiv }
									fieldsAndTitles={ getVisibleItems( subWidgets[ setting.name ].splashPageContentForm.fields, props.visibility ) }
								/>
							) : null }

							{ /* contact Settings Info */ }
							{ !isEmpty( settingInformation ) && 'whiteLabel' === setting.name ? (
								<WhiteLabelInfo
									fieldsAndTitles={ subWidgets[ setting.name ].fields }
									file={ settingInformation[ setting.name ].file }
									actionsVisibility={ settingInformation[ setting.name ].actionsVisibility }
									onActionClick= { props.onActionClick }
								/>
							) : null }
						</div>
					);
				} ) }

				{ /* button actions */ }
				<div className='ui-well-view-administration__settings__actions'>
					{ !isEmpty( settingInformation )
						? map( props.actions, ( action ) => {
								return (
									<Button
										key={ action.name }
										id={ action.name }
										{ ...action }
										outline={ 'cancel' === action.name ? true : false }
										size='large'
										className='ui-well-view-administration__settings__actions__action'
										onClick={
											isEqual( 'cancel', action.name )
												? () => {
														props.onClickCancel();
												}
												: () => props.onSaveClick()
										}
									/>
								);
						} )
						: null }
				</div>
			</div>
		</div>
	);
 };

// set display name
wellViewAdministrationSuccess.displayName = 'wellViewAdministrationSuccess';

// set default props
wellViewAdministrationSuccess.defaultProps = {};

// prop types
wellViewAdministrationSuccess.propTypes = {};

/********************************************** */

export const wellViewAdministrationPreloader = () => {
	return (
		<div className='ui-well-view-administration-preloader'>
			<div className='ui-well-view-administration-preloader__header'>
				<div className='ui-well-view-administration-preloader__header__title'></div>
				<div className='ui-well-view-administration-preloader__header__sub-title'></div>
				<div className='ui-well-view-administration-preloader__header__select'></div>
			</div>
			<div className='ui-well-view-administration-preloader__body'>
				{ times( 3 ).map( ( index ) => {
					return (
						<div
							key={ index }
							className='ui-well-view-administration-preloader__body__panel'
						>
							<div className='ui-well-view-administration-preloader__body__panel__icon'></div>
							<div className='ui-well-view-administration-preloader__body__panel__title'></div>
						</div>
					);
				} ) }
			</div>
		</div>
	);
 };

// set display name
wellViewAdministrationPreloader.displayName = 'wellViewAdministrationPreloader';

// set default props
wellViewAdministrationPreloader.defaultProps = {};

// prop types
wellViewAdministrationPreloader.propTypes = {};

/********************************************** */

export const wellViewAdministration = withNetworkState(
	wellViewAdministrationPreloader,
	wellViewAdministrationSuccess
);
